import React from 'react';
import { ShieldCheck, Receipt, Users, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const FeaturesSection = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: ShieldCheck,
      title: 'Credentialing',
      description: 'Provider enrollment and Medical Credentialing Services. We handle the long and complex process of getting your providers credentialed with insurance networks.',
      path: '/credentialing',
      video: '/assets/videos/credentialing-video.mp4'
    },
    {
      icon: Receipt,
      title: 'Medical Billing',
      description: 'Capital Billing Services Inc is an innovative Medical Billing and Practice Management company dedicated to providing your practice with the latest reimbursement strategies.',
      path: '/medical-billing',
      video: '/assets/videos/billing-video.mp4'
    },
    {
      icon: Users,
      title: 'Consulting',
      description: 'Capital Billing Services & Practice Management, Inc. is a consulting division that helps practices optimize their operations and maximize revenue.',
      path: '/consulting',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block bg-teal-500 text-white px-5 py-2 rounded-full text-sm font-semibold mb-4">
            Our Services
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Proven Process
          </h2>
          <p className="text-lg text-gray-600">
            Comprehensive medical billing and credentialing solutions designed to maximize your practice&apos;s revenue and efficiency
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-teal-200 hover:shadow-2xl transition-all duration-500"
              >
                {/* Image or Video */}
                <div className="relative h-48 overflow-hidden">
                  {feature.video ? (
                    <video
                      className="w-full h-full object-cover"
                      controls
                      preload="metadata"
                    >
                      <source src={feature.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <>
                      <img
                        src={feature.image}
                        alt={feature.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-navy-900/70 via-navy-900/20 to-transparent" />
                      <div className="absolute bottom-4 left-4">
                        <div className="bg-white/95 backdrop-blur-sm w-12 h-12 rounded-xl flex items-center justify-center shadow-lg">
                          <Icon className="w-6 h-6 text-teal-600" />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {feature.description}
                  </p>
                  <button
                    onClick={() => navigate(feature.path)}
                    className="inline-flex items-center text-teal-700 font-semibold text-sm group-hover:translate-x-2 transition-transform duration-300"
                  >
                    Read More
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
